var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4499 6.28464C28.7166 6.63464 29.7166 7.63464 30.0499 8.9013C30.6666 11.2013 30.6666 16.0013 30.6666 16.0013C30.6666 16.0013 30.6666 20.8013 30.0666 23.1013C29.7166 24.3846 28.7333 25.3846 27.4666 25.718C25.1666 26.3346 15.9999 26.3346 15.9999 26.3346C15.9999 26.3346 6.83325 26.3346 4.54992 25.718C3.28325 25.368 2.28325 24.368 1.94992 23.1013C1.33325 20.8013 1.33325 16.0013 1.33325 16.0013C1.33325 16.0013 1.33325 11.2013 1.93325 8.9013C2.28325 7.61797 3.26659 6.61797 4.53325 6.28464C6.83325 5.66797 15.9999 5.66797 15.9999 5.66797C15.9999 5.66797 25.1666 5.66797 27.4499 6.28464ZM20.6666 16.0013L12.9999 20.368V11.6346L20.6666 16.0013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cc5526cd0292dfcd45c99e78d0d6c91e.svg";
export { ForwardRef as ReactComponent };